import Message from 'semantic-ui-react/dist/commonjs/collections/Message';
import '@purple/semantic-ui-family-connection-theme/components/message.css';

export default Message;
